<template>
  <Card>
    <div
      v-if="pending"
      class="grid grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-4"
    >
      <Skeleton class="aspect-[5/7] w-full" />
    </div>

    <NamiGallery v-else-if="art" :gallery="art" />
  </Card>
</template>

<script setup lang="ts">
import { Cover, getCoverUrl, type TitleEntity } from "~/src/api";

const props = defineProps<{
  titleEntity: TitleEntity;
}>();
const titleId = props.titleEntity.id;

const { pending, data: art } = useAsyncData(
  `cover-art-${titleId}`,
  async () => {
    const covers = await Cover.search({ titleIds: [titleId], limit: 100 });

    return covers.data.map((cover) => ({
      url: getCoverUrl(cover)!,
    }));
  },
);
</script>
